import { hydrate, mount } from 'svelte';

import type { AcademicState } from '.';

import {
  AcademicTable,
  Gauge,
  Leaderboard,
  WrappedPercentChanged,
  WrappedPreviousScore,
} from '../../components';

import { makeConversation, processTableData } from '../fn';
import { group, leaderboard, refreshDate, overallScores } from '../api';

let academicState: AcademicState = $state({
  tableData: [],
  gauge: 0,
  prevScore: 0,
  percentChange: 0,
  percentChangePolarity: 'zero',
  refreshDate: 'Date loading...',
});

const DOM = {
  academicTable: document.getElementById('uc-tabulator'),
  gauge: document.getElementById('uc-gauge'),
  prevScore: document.getElementById('uc-previous-score'),
  percentChange: document.getElementById('uc-percent-change'),
  leaderboard: document.getElementById('uc-leaderboard'),
}

$inspect(academicState);

async function fetchEverythingAcademic(segment: string, groupCode: string) {
  const [groupResponse, leaderboardResponse, refreshDateResponse, overallScoresResponse] = await Promise.all([
    fetch(`${group}/${segment}/${groupCode}`),
    fetch(`${leaderboard}/${groupCode}`),
    fetch(refreshDate),
    fetch(`${overallScores}/${groupCode}`),
  ]);

  const groupData = await groupResponse.json();
  const leaderboardData = await leaderboardResponse.json()
  const refreshDateData = await refreshDateResponse.json()
  const overallScoresData = await overallScoresResponse.json()

  const formatDate = new Date(refreshDateData.data[0]["AllyRefreshDate"]).toLocaleDateString('en-us', {
    year: "numeric",
    month: "long",
    day: "numeric" 
  })

  return [groupData, leaderboardData, formatDate, overallScoresData.data[0]];
}

async function mountComponents(segment: string,) {
  console.log('mounting components', {
    segment,
    academicState,
  })
  if(DOM.gauge) {
    hydrate(Gauge, {
      target: DOM.gauge,
      props: {
        dashboardState: academicState,
        segment,
      }
    });
  }

  if(DOM.prevScore) {
    hydrate(WrappedPreviousScore, {
      target: DOM.prevScore,
      props: {
        dashboardState: academicState,
      }
    });
  }

  if(DOM.percentChange) {
    hydrate(WrappedPercentChanged, {
      target: DOM.percentChange,
      props: {
        dashboardState: academicState,
      }
    });
  }
  if(DOM.academicTable) {
    hydrate(AcademicTable, {
      target: DOM.academicTable,
    
      props: {
        tableData: [],
      }
    }
    )
  };
  if(DOM.leaderboard) {
    hydrate(Leaderboard, {
      target: DOM.leaderboard,
      props: {
        data: [],
      }
    })
  };
}

export async function buildAcademic(segment: string|undefined = 'academic', groupCode: string|undefined = 'uc') {
  // let the components (including coversation) mount asyncronously while we move on to fetching their data
  mountComponents(segment);
  makeConversation();

  // fetch the data
  const [groupData, leaderboardData, formatDate, overallScoresData] = await fetchEverythingAcademic(segment, groupCode);
  academicState.gauge = overallScoresData.RecentAllyScore;
  // academicState.tableData = groupData.data;
  academicState.refreshDate = formatDate;
  console.log('formatDate', formatDate);

  // massage data & update academicState as things are prepped
  groupData.data.forEach((_, i)=> {
    if(i === 0) {
      academicState.prevScore = Number(_.PreviousOverallScore);

      // use the % change from the payload
      if (_.PercentChange == 0) {
        academicState.percentChange = 0;
        academicState.percentChangePolarity = 'zero'
        // change = 0;
        // changePolarity = 'zero'
      } else if (_.PercentChange < 0) {
        academicState.percentChange = Number(_.PercentChange)  * -1;
        academicState.percentChangePolarity = 'negative'
      } else {
        academicState.percentChange = Number(_.PercentChange);
        academicState.percentChangePolarity = 'positive'
      }

      console.log('academicState after 0', academicState);
    }
  });

  if(DOM.academicTable) {
    hydrate(AcademicTable, {
      target: DOM.academicTable,
      props: {
        tableData: processTableData(groupData.data)
      }
    })
  };
  
  if(DOM.leaderboard) {
    hydrate(Leaderboard, {
      target: DOM.leaderboard,
      props: {
        data: leaderboardData.data,
      }
    })
  };

  
}